package empiresmp.feature.votes.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.Anchor
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import empiresmp.components.FilledText
import empiresmp.components.FlowRow
import empiresmp.components.PlatformExt
import empiresmp.components.Spacer
import empiresmp.components.layouts.PageLayout
import empiresmp.components.navbar.EmpireSmpDesktopNavBar
import empiresmp.feature.main.presentation.model.MainPagerModel
import empiresmp.feature.main.ui.component.MainPagerModelContent
import empiresmp.feature.votes.presentation.VotesComponent
import org.jetbrains.compose.web.css.percent
import ru.astrainteractive.kobwebx.core.resource.Resources
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

private fun VotesComponent.VoteUrl.asIcon(): String {
    return when (this) {
        is VotesComponent.VoteUrl.HotMc -> Resources.icHotMc.path
        is VotesComponent.VoteUrl.MinecraftRating -> Resources.icMinecraftRating.path
        is VotesComponent.VoteUrl.MinecraftRatingProject -> Resources.icMinecraftRating.path
    }
}

@Suppress("MaxLineLength", "MaximumLineLength", "LongMethod")
@Composable
fun VotesPageContent() {
    val theme = LocalSitePalette.current
    val votesComponent = VotesComponent()
    val voteUrls by votesComponent.urls.collectAsState()
    PageLayout {
        EmpireSmpDesktopNavBar()
        Column(modifier = Modifier.fillMaxSize()) {
            MainPagerModelContent(MainPagerModel.Monitoring)
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.borderRadius(theme.dimens.S)
                        .background(theme.colors.colorPrimary)
                        .padding(theme.dimens.M)
                        .thenIf(PlatformExt.isMobilePlatform, Modifier.maxWidth(90.percent))
                        .thenIf(!PlatformExt.isMobilePlatform, Modifier.maxWidth(40.percent)),
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.spacedBy(theme.dimens.S)
                ) {
                    FilledText(
                        text = "Обратите внимание на эти значки!",
                        fillColor = theme.colors.colorSecondary,
                        textColor = theme.colors.colorOnSecondary,
                        modifier = Modifier.fillMaxWidth()
                            .textAlign(TextAlign.Center)
                    )
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(theme.dimens.S),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconBackgroundComposable(
                            icon = Resources.icPrize.path,
                            background = theme.colors.colorSecondaryVariant
                        )
                        SpanText(
                            text = "Он означает, что за голосование вы получите награду!" +
                                "(в данный момент награды не выдаются," +
                                " но ваши голоса запоминаются, чтобы выдать награду позже!)",
                            modifier = theme.typography.h5
                                .toModifier()
                                .fontWeight(FontWeight.Companion.Bold)
                                .color(theme.colors.colorOnPrimary)
                                .cursor(Cursor.Companion.Text)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Row(
                        horizontalArrangement = Arrangement.spacedBy(theme.dimens.S),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconBackgroundComposable(
                            icon = Resources.icCheck.path,
                            background = theme.colors.colorSuccess
                        )
                        SpanText(
                            text = "Он означает, что вы уже кликали на этот сервер",
                            modifier = theme.typography.h5
                                .toModifier()
                                .fontWeight(FontWeight.Companion.Bold)
                                .color(theme.colors.colorOnPrimary)
                                .cursor(Cursor.Companion.Text)
                                .textAlign(TextAlign.Start)
                        )
                    }
                }
            }
            Spacer()
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                voteUrls.groupBy {
                    when (it) {
                        is VotesComponent.VoteUrl.HotMc -> 1
                        is VotesComponent.VoteUrl.MinecraftRating -> 2
                        is VotesComponent.VoteUrl.MinecraftRatingProject -> 3
                    }
                }.forEach { (_, voteUrls) ->
                    FlowRow {
                        voteUrls.forEachIndexed { i, voteUrl ->
                            Anchor(
                                href = voteUrl.url,
                                attrs = Modifier.textDecorationLine(TextDecorationLine.None).padding(theme.dimens.S)
                                    .toAttrs(),
                                openInternalLinksStrategy = null,
                                openExternalLinksStrategy = null,
                            ) {
                                ButtonWithIconComposable(
                                    icon = voteUrl.asIcon(),
                                    text = voteUrl.name,
                                    onClick = {
                                        votesComponent.onClicked(voteUrl)
                                    },
                                    hasAward = voteUrl.hasAward,
                                    isVoted = voteUrl.isClickedBefore
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
